// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3OJos","title":"FrontImage_title__3fkSt"};